namespace $.$$ {
	/** Compact ghost button for inline toolbars / text flows (inherits `$eve_button`). */
	export class $eve_button_inline extends $.$eve_button_inline {}
}
